
const RollingLoader = () => {
  return (
    <div
      style={{ position: 'absolute', right: '0px',zIndex:2 }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" style={{ margin: 'auto', background: 'none', display: 'block', shapeRendering: 'auto' }} width={40} height={40} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <circle cx="50" cy="50" fill="none" stroke="#dd4433" stroke-width="5" r="20" stroke-dasharray="94.24777960769379 33.41592653589793">
          <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
        </circle>
      </svg>
    </div>
  );
}

export default RollingLoader